module.exports = __webpack_public_path__ + "img/shiba-body-level3.4d1a143b.png";